import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedColumn, removeSelectedColumn } from '../redux/columnsSlice';

const ProcedureTable = ({ procedureName, columns, data }) => {
  const dispatch = useDispatch();

  const rawRows = data ?? [];

  // Optimización: Evitar renders innecesarios con `useMemo`
  const selectedColumns = useSelector(
    (state) => state.columns.selectedColumns[procedureName] || [],
    (prev, next) => prev.length === next.length && prev.every((v, i) => v === next[i])
  );

  // Optimización: Memoizar función de alternar columnas
  const handleColumnToggle = useCallback(
    (colName) => {
      if (colName === 'order_id') return;

      if (selectedColumns.includes(colName)) {
        dispatch(removeSelectedColumn({ procedure: procedureName, column: colName }));
      } else {
        dispatch(addSelectedColumn({ procedure: procedureName, column: colName }));
      }
    },
    [dispatch, procedureName, selectedColumns]
  );

  return (
    <div className="autocrm-procedure-block">
      <h3>Procedimiento: {procedureName}</h3>
      <table className="autocrm-data-table">
        <thead className="autocrm-data-table-head">
          <tr>
            {columns.map((colName) => (
              <th key={colName}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(colName) || colName === 'order_id'}
                    disabled={colName === 'order_id'}
                    onChange={() => handleColumnToggle(colName)}
                  />
                  <span className="autocrm-column-label">{colName}</span>
                </label>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="autocrm-data-table-body">
          {rawRows.length > 0 ? (
            rawRows.map((row) => (
              <tr key={row.order_id || row.id || JSON.stringify(row)}>
                {columns.map((colName) => (
                  <td key={colName}>{row[colName] ?? 'N/A'}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length}>No hay datos disponibles.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

ProcedureTable.propTypes = {
  procedureName: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
};

ProcedureTable.defaultProps = {
  data: [],
};

export default ProcedureTable;
